export default new class BuyCounter {
  constructor() {
    this.sDefaultInputClass = '_buy-quantity';
    this.sIncreaseInputClass = '_buy-increase-quantity';
    this.sDecreaseInputClass = '_buy-decrease-quantity';

    this.iDelayBeforeRequest = 400;
    this.obTimer = null;

    this.initInput();
    this.initIncrease();
    this.initDecrease();
  }

  /**
   * Init update event
   */
  initInput() {
    $(document).on('input', `.${this.sDefaultInputClass}`, (obEvent) => {
      if (this.obTimer !== null) {
        clearTimeout(this.obTimer);
      }

      this.obTimer = setTimeout(() => {
        const { currentTarget: obInput } = obEvent;
        const iMaxQuantity = this.getMaxQuantity(obInput);
        let iQuantity = this.getQuantity(obInput);
        if (iQuantity < 1) {
          iQuantity = 1;
        }

        if (iQuantity > iMaxQuantity) {
          obInput.value = iMaxQuantity;
        }
      }, this.iDelayBeforeRequest);
    });
  }

  /**
   * Init increase event
   */
  initIncrease() {
    $(document).on('click', `.${this.sIncreaseInputClass}`, (obEvent) => {
      if (this.obTimer !== null) {
        clearTimeout(this.obTimer);
      }

      const { currentTarget: obButton } = obEvent;

      const obInput = document.querySelector(`.${this.sDefaultInputClass}`);
      const iMaxQuantity = this.getMaxQuantity(obInput);
      const iQuantity = this.getQuantity(obInput) + 1;
      if (iQuantity > iMaxQuantity) {
        return;
      }

      obInput.value = iQuantity;
      if (iQuantity === iMaxQuantity) {
        obButton.setAttribute('disabled', 'disabled');
      } else {
        obButton.removeAttribute('disabled');
      }

      if (iQuantity > 1) {
        const obDecreaseButton = document.querySelector(`.${this.sDecreaseInputClass}`);
        if (obDecreaseButton) {
          obDecreaseButton.removeAttribute('disabled');
        }
      }
    });
  }

  /**
   * Init decrease event
   */
  initDecrease() {
    $(document).on('click', `.${this.sDecreaseInputClass}`, (obEvent) => {
      if (this.obTimer !== null) {
        clearTimeout(this.obTimer);
      }

      const { currentTarget: obButton } = obEvent;
      const obInput = document.querySelector(`.${this.sDefaultInputClass}`);
      const iMaxQuantity = this.getMaxQuantity(obInput);
      const iQuantity = this.getQuantity(obInput) - 1;
      if (iQuantity < 1) {
        return;
      }

      obInput.value = iQuantity;
      if (iQuantity === 1) {
        obButton.setAttribute('disabled', 'disabled');
      } else {
        obButton.removeAttribute('disabled');
      }

      if (iQuantity < iMaxQuantity) {
        const obIncreaseButton = document.querySelector(`.${this.sIncreaseInputClass}`);
        if (obIncreaseButton) {
          obIncreaseButton.removeAttribute('disabled');
        }
      }
    });
  }

  getQuantity(obInput) {
    return parseInt(obInput.value, this.iRadix);
  }

  /**
   * Get offer quantity from cart object
   */
  getMaxQuantity(obInput) {
    return parseInt(obInput.getAttribute('max'), this.iRadix);
  }
}();
